module.exports = __webpack_public_path__ + "img/logo.a1a84848.png";